import React, { useEffect, useState } from 'react'
import Header from '../comman/Header'
import Footer from '../comman/Footer'
import { apiRequest } from '../../utils/config/apiRequest'
import { apiUrl } from '../../utils/endPoints/apiUrl'
import './Privacy.css'

export default function Privacy() {
    const [content, setContent] = useState('')
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        })

        fetchPolicy()
    }, [])

    const fetchPolicy = async () => {
        setLoading(true)
        setError(false)

        try {
            const { data, status } = await apiRequest({
                endUrl: apiUrl.legals,
                query: {
                    type: 'TERMS_AND_CONDITION'
                }
            })

            if (status) {
                setContent(data?.description || '')
            } else {
                setError(true)
            }
        } catch (err) {
            console.error(err)
            setError(true)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="privacy-page">
            <Header />

            {/* Hero */}
            <section className="privacy-hero">
                <div className="privacy-hero-decoration privacy-decoration-one" />
                <div className="privacy-hero-decoration privacy-decoration-two" />

                <div className="privacy-hero-content">
                    <h1>Terms & Conditions</h1>

                    <p>
                        Please read these terms and conditions carefully before using
                        our services. By accessing or using our services, you agree
                        to be bound by these terms.
                    </p>
                </div>
            </section>

            {/* Content */}
            <main className="privacy-container">
                <div className="privacy-card">

                    {loading && (
                        <div className="privacy-state">
                            <div className="privacy-spinner" />

                            <p>
                                Loading terms & conditions ...
                            </p>
                        </div>
                    )}

                    {!loading && error && (
                        <div className="privacy-state">
                            <div className="privacy-error-icon">
                                !
                            </div>

                            <h2>
                                Unable to load terms & conditions
                            </h2>

                            <p>
                                Something went wrong while loading the
                                terms & conditions.
                            </p>

                            <button
                                onClick={fetchPolicy}
                                className="privacy-retry-button"
                            >
                                Try Again
                            </button>
                        </div>
                    )}

                    {!loading && !error && (
                        <div className="privacy-content">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: content,
                                }}
                            />
                        </div>
                    )}
                </div>
            </main>

            <Footer />
        </div>
    )
}